export const APP_VERSION = '1.0.0';

export const ENABLE_REDUX_DEV_TOOLS = true;

export const THEMES = {
    BRP_LIGHT: 'BRP_LIGHT',
    BRP_DARK: 'BRP_DARK',

    LIGHT: 'LIGHT',
    ONE_DARK: 'ONE_DARK',

    DARK_PINK: 'DARK_PINK',
    LIGHT_PINK: 'LIGHT_PINK',

    DARK_BLUE: 'DARK_BLUE',
    LIGHT_BLUE: 'LIGHT_BLUE',

    DARK_RED: 'DARK_RED',
    LIGHT_RED: 'LIGHT_RED',

    DARK_REGGAE: 'DARK_REGGAE',
    LIGHT_REGGAE: 'LIGHT_REGGAE',

    DARK_LILA: 'DARK_LILA',
    LIGHT_LILA: 'LIGHT_LILA',

    CHRISTMAS_LIGHT: 'CHRISTMAS_LIGHT',
    CHRISTMAS_DARK: 'CHRISTMAS_DARK',

    CUSTOM_THEME: 'CUSTOM_THEME',
};
